/**
 * Triggers a callback function once the window has fully loaded.
 *
 * @param {Function} callback The function to trigger
 */
export default function onLoad(callback) {
  if (window.readyState === 'complete') {
    callback()
  } else {
    window.addEventListener('load', callback)
  }
}
